import React from 'react';
import image from "../../Imges/about-img_1920x400.jpg"
const Aboutpage = () => {
    return (
        <section className='sbout-page-div'>
            <img src={image} alt='' className='w-100' />
        </section>
    );
};

export default Aboutpage;